import _ from 'lodash';
import {fromJS, Map} from 'immutable';

import * as actions from './actions';


export default function(state = fromJS({elementId: window.uuidv4()}), action) {
    if (!state.get('openedMaterials'))
        state = state.set('openedMaterials', new Map());
    if (!state.get('selectedMaterials'))
        state = state.set('selectedMaterials', new Map());
    if (!state.get('openedSubjects'))
        state = state.set('openedSubjects', new Map());
    if (!state.get('selectedSubjects'))
        state = state.set('selectedSubjects', new Map());

    switch (action.type) {
    case actions.SET_MATERIALS:
        const materials = _.mapKeys(action.payload, material => material.id);
        state = state.set('materials', fromJS(materials));
        break;

    case actions.ADD_MATERIAL:
        state = state.setIn(
            ['materials', String(action.payload.id)],
            fromJS(action.payload),
        );
        break;

    case actions.REMOVE_MATERIAL:
        state = state.removeIn(
            ['materials', String(action.payload.id)],
        );
        break;

    // case actions.UPDATE_MATERIAL:
    //     state = state.updateIn(
    //         ['materials', state.get('materials').findIndex(
    //             item => item.get('id') == action.payload.id,
    //         )],
    //         () => fromJS(action.payload),
    //     );
    //     break;

    case actions.SET_SUBJECTS:
        const subjects = _.mapKeys(action.payload, subject => subject.id);
        state = state.set('subjects', fromJS(subjects));
        break;

    case actions.ADD_SUBJECT:
        state = state.setIn(
            ['subjects', String(action.payload.id)],
            fromJS(action.payload),
        );
        break;

    case actions.REMOVE_SUBJECT:
        state = state.removeIn(
            ['subjects', String(action.payload.id)],
        );
        break;

    // case actions.UPDATE_SUBJECT:
    //     state = state.updateIn(
    //         ['subjects', state.get('subjects').findIndex(
    //             item => item.get('id') == action.payload.id,
    //         )],
    //         () => fromJS(action.payload),
    //     );
    //     break;
    }

    if (action.elementId !== state.get('elementId')) {
        return state;
    }

    function parentRoot(item) {
        return (item.get('parent')
            ? parentRoot(state.get('subjects').get(
                String(item.get('parent')),
            ))
            : state.get('materials').get(
                String(item.get('material')),
            ).get('title')
        ) + ' ← ' + item.get('title');
    }

    switch (action.type) {
    case actions.TOGGLE_MATERIAL:
        state = state.updateIn(
            ['openedMaterials'], new Map(), opened => opened.set(
                action.payload.id,
                !opened.get(action.payload.id, false),
            ),
        );
        break;

    case actions.TOGGLE_MATERIAL_SELECTION:
        state = state.updateIn(
            ['selectedMaterials'], new Map(), selected => selected.set(
                action.payload.id,
                !selected.get(action.payload.id, false),
            ),
        );
        break;

    case actions.TOGGLE_SUBJECT:
        state = state.updateIn(
            ['openedSubjects'], new Map(), opened => opened.set(
                action.payload.id,
                !opened.get(action.payload.id, false),
            ),
        );
        break;

    case actions.SET_SELECTED_SUBJECTS:
        const selection = _.mapValues(
            _.mapKeys(
                action.payload,
            ),
            id => state.get('subjects') && state.get('subjects').get(String(id))
            ? parentRoot(state.get('subjects').get(String(id)))
            : null,
        );
        state = state.set(
            'selectedSubjects',
            fromJS(selection),
        );
        break;

    case actions.TOGGLE_SUBJECT_SELECTION:
        const id = String(action.payload.id);

        if (state.get('selectedSubjects').get(id)) {
            state = state.removeIn(
                ['selectedSubjects', id],
            );
        }
        else {
            state = state.setIn(
                ['selectedSubjects', id],
                parentRoot(state.get('subjects').get(id)),
            );
        }
        break;

    case actions.REMOVE_SUBJECT_SELECTION:
        {
            const id = String(action.payload);
            state = state.removeIn(
                ['selectedSubjects', id],
            );
            break;
        }
    }
    return state;
}
